export const data_kowloon = {
   splat: "https://assets.deepworldmodel.ai/playground/scene/kowloon.sog",
   mesh: "https://assets.deepworldmodel.ai/playground/scene/kowloon_mesh.glb",
   avatar:
      "https://assets.deepworldmodel.ai/playground/avatar/labubuRun_20260630_1720.glb",
   scale: 0.5,
   camera: {
      position: {
         x: 1,
         y: 0.2,
         z: -1,
      },
      target: {
         x: 0,
         y: -0.5,
         z: 0,
      },
   },
   path: {
      position: [
         [1.055312156677246, -1.461909294128418, 1.2592366933822632],
         [0.7655024528503418, -1.46157705783844, 1.1645259857177734],
         [0.4899982213973999, -1.4591503143310547, 1.0374172925949097],
         [0.222731813788414, -1.4615803956985474, 0.8924714922904968],
         [-0.0364491306245327, -1.4720324277877808, 0.7353335618972778],
         [-0.17273791134357452, -1.4574363231658936, 0.4564657509326935],
         [-0.2557278275489807, -1.4581536054611206, 0.16532474756240845],
         [-0.3434620499610901, -1.4567348957061768, -0.1263948231935501],
         [-0.4827461242675781, -1.456700325012207, -0.40641480684280396],
         [-0.7690699696540833, -1.4585485458374023, -0.5267849564552307],
         [-0.9279866814613342, -1.4596363306045532, -0.26963964104652405],
         [-0.736596405506134, -1.4681806564331055, -0.037599653005599976],
         [-0.49144577980041504, -1.459643840789795, 0.14035038650035858],
         [-0.22987468540668488, -1.4570337533950806, 0.2937692105770111],
         [0.03479136899113655, -1.459265947341919, 0.4432560205459595],
         [0.30235564708709717, -1.4643248319625854, 0.5867690443992615],
         [0.5684751868247986, -1.4612892866134644, 0.7298089861869812],
         [0.8326209783554077, -1.4621922969818115, 0.8800975680351257],
         [1.075566053390503, -1.4561998844146729, 1.0610333681106567],
         [1.1759459972381592, -1.4615675210952759, 1.3479938507080078],
         [0.8651430606842041, -1.458956241607666, 1.3644843101501465],
         [0.6067180633544922, -1.4584611654281616, 1.2032757997512817],
         [0.3527383506298065, -1.4657495021820068, 1.0371004343032837],
         [0.15024709701538086, -1.4663901329040527, 0.8141165375709534],
         [-0.02941918559372425, -1.458938717842102, 0.5529446601867676],
      ],
      target: [
         [0.09990431103654196, -1.461909294128418, 0.9639472616577461],
         [-0.17382914447907782, -1.46157705783844, 0.8215155627587019],
         [-0.39497832692964363, -1.4591503143310547, 0.571781695898145],
         [-0.652013745879181, -1.4615803956985474, 0.4078889855469848],
         [-0.7424100774716011, -1.4720324277877808, 0.027082800142099184],
         [-0.47458584581550334, -1.4574363231658936, -0.49689033388295933],
         [-0.52002445256683, -1.4581536054611206, -0.7991166938969341],
         [-0.6676753740572894, -1.4567348957061768, -1.0723788190827475],
         [-1.1816058918373658, -1.456700325012207, -1.1216735189689147],
         [-1.7683572310215139, -1.4585485458374023, -0.564533721584444],
         [-0.45834762933064577, -1.4596363306045532, 0.6132188757690461],
         [0.028299091066046334, -1.4681806564331055, 0.6065547379004914],
         [0.3662052934025847, -1.459643840789795, 0.6545824709075285],
         [0.6355775123720734, -1.4570337533950806, 0.7947607208443183],
         [0.9159807128028645, -1.459265947341919, 0.9160195347395318],
         [1.18376191752874, -1.4643248319625854, 1.0591280036941542],
         [1.4481792771035624, -1.4612892866134644, 1.2053305036252693],
         [1.6891910566350627, -1.4621922969818115, 1.3961282851402081],
         [1.7743946546613367, -1.4561998844146729, 1.7763225306497308],
         [0.8979824672770707, -1.4615675210952759, 2.3085854788266227],
         [0.029989099632579563, -1.458956241607666, 0.8144680728082097],
         [-0.25056521992073133, -1.4584611654281616, 0.6884308015072931],
         [-0.44041947806097137, -1.4657495021820068, 0.4280842942983323],
         [-0.40925665692338675, -1.4663901329040527, -0.014711278883361212],
         [-0.565102680683141, -1.458938717842102, -0.291474189134342],
      ],
   },
};
